var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart"},[_c('vuestic-chart',{staticClass:"chart",attrs:{"data":_vm.chartData,"type":"vertical-bar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }